export const SET_AUTH_USER = 'SET_AUTH_USER';
export const UNSET_AUTH_USER = 'UNSET_AUTH_USER';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const UPDATE_PROFILE_STATUS = 'UPDATE_PROFILES_STATUS';